import { render, staticRenderFns } from "./WizardHeader.vue?vue&type=template&id=fe788fa4&scoped=true&"
import script from "./WizardHeader.vue?vue&type=script&lang=js&"
export * from "./WizardHeader.vue?vue&type=script&lang=js&"
import style0 from "./WizardHeader.vue?vue&type=style&index=0&id=fe788fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe788fa4",
  null
  
)

export default component.exports